/**
 * Whether a formula builder offers "Lowest" (02/11/2026). The Automation's
 * formulas do — their rankers give lowest() its max over the ranked items —
 * the Flow Optimizer does not, so its builders render exactly as before.
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, FC, ReactNode, useContext } from 'react';

const LowestContext = createContext(false);

export const LowestProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <LowestContext.Provider value>{children}</LowestContext.Provider>
);

export const useAllowLowest = (): boolean => useContext(LowestContext);
